export default __webpack_public_path__ + "static/home2-d8598a515338288785977c2c47c19272.webp";